import api from '../api';

export const duplicate = async (projectId, formGroupId, formGroupName) => {
  const res = await api.post(`/projects/${projectId}/formgroups/${formGroupId}/duplicate`, { formGroupName });
  return res.data;
};

export const getEngagementsByFormGroup = async (projectId, params) => {
  const {
    formGroupId,
    startDate,
    endDate,
    pageIndex = 0,
    pageSize = 10,
    search = '',
    status = 'pending',
    sorting = [],
    omitStatus = false,
  } = params;

  const query = new URLSearchParams({
    startDate,
    endDate,
    page: pageIndex,
    size: pageSize,
    search,
    sort: JSON.stringify(sorting),
  });
  if (!omitStatus) {
    query.set('status', status);
  }

  const { data } = await api.get(
    `/engagements/formgroups/${formGroupId}?${query.toString()}`
  );

  const payload = data?.data || data;
  return {
    data: payload?.engagements || [],
    pageCount: payload?.totalPages || 0,
    totalItems: payload?.totalItems || 0
  };
};


export const deleteForm = async (projectId, formId) => {
  const res = await api.delete(`/projects/${projectId}/forms/${formId}`);
  return res.data;
};

export const updateForm = async (projectId, formId, name) => {
  const res = await api.put(`/projects/${projectId}/forms/${formId}/rename`, { name });
  return res.data;
};

export const createForm = async () => {
  return;
}